<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close"
                  @click="$emit('close')"
                  aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Editar dados do estudante
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <form>
            <div v-if="inputError" class="alert alert-danger">
              {{ inputError }}
            </div>
            <div class="row student-edit__form">
              <div class="col-md-6">
                <label for="student-name">Nome</label>
                <input @click="inputError = null"
                       type="text"
                       class="form-control"
                       id="student-name"
                       v-model="currentStudent.name"
                >
              </div>
              <div class="col-md-3">
                <label for="student-cpf">CPF</label>
                <input @click="inputError = null"
                       type="text"
                       class="form-control"
                       id="student-cpf"
                       v-model="currentStudent.cpf"
                       v-mask="['###.###.###-##']"
                >
              </div>
              <div class="col-md-3">
                <label for="student-cellphone">Telefone</label>
                <input @click="inputError = null"
                       class="form-control"
                       id="student-cellphone"
                       :value="currentStudent.formatted_cellphone"
                       @change="changeCellphone($event.target.value)"
                       v-mask="['(##) ####-####', '(##) #####-####']"
                >
              </div>
            </div>
            <div class="row student-edit__form">
              <div class="col-md-4">
                <label for="student-email">E-mail</label>
                <input @click="inputError = null"
                       type="email"
                       class="form-control"
                       id="student-email"
                       v-model="currentStudent.email"
                >
              </div>
              <div class="col-md-4">
                <label for="student-state">Estado</label>
                <autocomplete ref="statesAutocomplete"
                              :list="states"
                              name="student-states"
                              @selected="chooseState"
                              input-class="form-control"
                />
              </div>
              <div class="col-md-4">
                <label for="student-city">Cidade</label>
                <autocomplete ref="citiesAutocomplete"
                              :list="studentCities"
                              name="student-cities"
                              @selected="chooseCity"
                              input-class="form-control"
                />
              </div>
            </div>
            <div class="row student-edit__form">
              <div class="col-md-4">
                <label for="student-birthday">Nascimento</label>
                <date-picker v-model="studentBirthday" :config="datePickerOptions" />
              </div>
              <div class="col-md-4">
                <label for="student-rg">RG</label>
                <input type="text" class="form-control" id="student-rg" v-model="currentStudent.identity_card">
              </div>
              <div class="col-md-4">
                <label for="student-ssp">Orgão expeditor</label>
                <input type="text" class="form-control" id="student-ssp" v-model="currentStudent.identity_card_emissor">
              </div>
            </div>
            <div class="row student-edit__form">
              <div class="col-md-4">
                <label for="student-address">Endereço</label>
                <input type="text" class="form-control" id="student-address" v-model="currentStudent.address">
              </div>
              <div class="col-md-4">
                <label for="student-rg">Número</label>
                <input type="text" class="form-control" id="student-rg" v-model="currentStudent.address_number">
              </div>
              <div class="col-md-4">
                <label for="student-rg">Complemento</label>
                <input type="text" class="form-control" id="student-rg" v-model="currentStudent.address_complement">
              </div>
            </div>
            <div class="row student-edit__form">
              <div class="col-md-4">
                <label for="student-male">Bairro</label>
                <input type="text" class="form-control" id="student-male" v-model="currentStudent.neighborhood">
              </div>
              <div class="col-md-4">
                <label for="student-address">CEP</label>
                <input type="text" class="form-control" id="student-address" v-model="currentStudent.postal_code">
              </div>
              <div class="col-md-4">
                <label for="student-male">Sexo</label>
                <select v-model="currentStudent.gender" class="form-control">
                  <option value="M">
                    Masculino
                  </option>
                  <option value="F">
                    Feminino
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="saveData">
            Salvar novos dados do aluno
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import CPF from 'cpf';
import 'moment/locale/pt-br';
import { mapActions, mapState } from 'vuex';
import StudentsService from 'services/StudentsService';
import DatePicker from 'vue-bootstrap-datetimepicker';
import Autocomplete from 'components/autocomplete';
import AddressService from 'services/AddressService';

export default {
  data() {
    return {
      currentStudent: null,
      studentBirthday: null,
      inputError: null,
      loadedCities: null,
      datePickerOptions: {
        icons: {
          time: 'far fa-clock',
          date: 'far fa-calendar',
          up: 'fas fa-arrow-up',
          down: 'fas fa-arrow-down',
          previous: 'fas fa-chevron-left',
          next: 'fas fa-chevron-right',
          today: 'fas fa-calendar-check',
          clear: 'far fa-trash-alt',
        },
        tooltips: {
          clear: 'Limpar',
        },
        format: 'DD/MM/YYYY',
        locale: moment.locale('pt-BR'),
        showClear: true,
        showClose: false,
      },
      emailChanged: false,
      message: '',
    };
  },
  components: {
    DatePicker,
    Autocomplete,
  },
  computed: {
    ...mapState([
      'student',
      'states',
      'cities',
    ]),
    studentCities() {
      return this.loadedCities || this.cities || [];
    },
  },
  created() {
    this.currentStudent = Object.assign({}, this.student);
  },
  mounted() {
    if (this.currentStudent.birthday) this.studentBirthday = moment(this.currentStudent.birthday).format('DD/MM/YYYY');
    if (this.currentStudent.state_id) this.$refs.statesAutocomplete.setOption(this.currentStudent.state_id);
    if (this.currentStudent.city_id) this.$refs.citiesAutocomplete.setOption(this.currentStudent.city_id);
  },
  methods: {
    ...mapActions([
      'loadStudent',
      'loadCities',
    ]),
    chooseState(stateId) {
      this.currentStudent.state_id = stateId;
      this.$refs.citiesAutocomplete.clear();
      AddressService.getCities(stateId)
        .then(({ cities }) => {
          this.loadedCities = cities;
        });
    },
    chooseCity(cityId) {
      this.currentStudent.city_id = cityId;
    },
    validate() {
      return this.currentStudent.name && this.currentStudent.email && this.currentStudent.formatted_cellphone;
    },
    validateCellphone() {
      const cellphoneLength = this.currentStudent.formatted_cellphone.replace(new RegExp('\\D', 'g'), '').length;
      return (cellphoneLength === 10 || cellphoneLength === 11);
    },
    saveData() {
      if (!this.validate()) {
        this.inputError = 'Os seguintes dados são obrigatórios: nome, e-mail e telefone';
        return;
      }
      if (!this.validateCellphone()) {
        // eslint-disable-next-line max-len
        this.inputError = 'O formato do telefone deve ser (##) ####-#### ou (##) #####-####, verifique se não esqueceu de nenhum número';
        return;
      }
      if (!CPF.isValid(this.currentStudent.cpf)) {
        this.inputError = 'CPF inválido';
        return;
      }
      if (this.studentBirthday) {
        this.currentStudent.birthday = moment(this.studentBirthday, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      if (this.student.email !== this.currentStudent.email) {
        this.emailChanged = true;
      }
      this.$loader.show();
      this.$emit('close');

      StudentsService.saveStudentData(this.currentStudent)
        .then(() => {
          if (this.emailChanged) {
            this.message = 'O e-mail será atualizado somente após a confirmação do aluno.';
          }
          this.$alert.notifySuccess(`Dados do aluno salvos. ${this.message}`);
          this.loadStudent(this.currentStudent.id);
          this.loadCities();
        })
        .catch(({ response }) => {
          this.$alert.notifyAlert(`Falha ao salvar dados do aluno: ${response.data.message}`);
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
    changeCellphone(input) {
      this.currentStudent.formatted_cellphone = input;
      this.currentStudent.cellphone = input;
    },
  },
};
</script>
